<div class="header bg-cool-gray-100" #headerContainer>
  <!-- Header left -->
  <div class="left" #leftContainer>
    <div class="breadcrumb">
      <span data-cy="deal-title-label" class="path">
        <a [routerLink]="[projectPipelineRoute]">{{ project.pipeline.name }}</a>
        <span class="separator">/</span>
        <ng-container *ngIf="hasParent()">
          <a
            [routerLink]="[projectPipelineRoute + '/' + project.parents[0].id + '/details/overview']"
            data-cy="project-parent-title"
            >{{ project.parents[0].title }}</a
          >
          <span class="separator">/</span></ng-container
        >
        <span data-cy="project-title">{{ project.title }} </span>
      </span>
    </div>
  </div>

  <div class="menu" #menuContainer>
    <!-- DETAILS TAB -->
    <a
      [appAuthorize]="hasPermission(Permission.DETAILS_TAB)"
      [routerLink]="[projectRoute + '/details']"
      [routerLinkActive]="['active']"
      [routerLinkActiveOptions]="{ subset: true }"
      >Details</a
    >
    <!-- FILES TAB -->
    <a
      [appAuthorize]="hasPermission(Permission.FILES_TAB)"
      [routerLink]="[projectRoute + '/folders']"
      [routerLinkActive]="['active']"
      data-cy="project-files-tab"
      >Files
      <span class="badge" *ngIf="project.num_documents && project.num_documents > 0">{{
        project.num_documents
      }}</span></a
    >
    <!-- TASKS TAB -->
    <!-- <a
      [appAuthorize]="hasPermission(Permission.TASKS_TAB)"
      [routerLink]="[projectRoute + '/tasks']"
      [routerLinkActive]="['active']"
      data-cy="project-tasks-tab"
      >Tasks
      <span class="badge" *ngIf="project.num_open_tasks && project.num_open_tasks > 0">{{
        project.num_open_tasks
      }}</span></a
    > -->
    <!-- NEWTASKS TAB -->
    <a
      [appAuthorize]="hasPermission(Permission.TASKS_TAB)"
      [routerLink]="[projectRoute + '/new-tasks/Project/' + project.id]"
      [routerLinkActive]="['active']"
      data-cy="-new-project-tasks-tab"
      >Tasks
      <span class="badge" *ngIf="project.num_open_tasks && project.num_open_tasks > 0">{{
        project.num_open_tasks
      }}</span></a
    >
    <!-- NOTES TAB -->
    <a
      [appAuthorize]="hasPermission(Permission.NOTES_TAB)"
      [routerLink]="[projectRoute + '/notes']"
      [routerLinkActive]="['active']"
      data-cy="project-notes-tab"
      >Notes <span class="badge" *ngIf="project.num_notes && project.num_notes > 0">{{ project.num_notes }}</span></a
    >
    <!-- INSIGHTS & LEASES TAB -->
    <ng-container *ngIf="project && project.properties && project.properties?.length > 0">
      <a
        [appAuthorize]="hasPermission(Permission.INSIGHTS_TAB)"
        [routerLink]="[projectRoute + '/insights']"
        [routerLinkActive]="['active']"
        >Insights</a
      >
      <a [routerLink]="[projectRoute + '/leases']" [routerLinkActive]="['active']" data-cy="project-leases-tab"
        ><ng-container *ngIf="!account || account.subdomain != 'standard'">Leases</ng-container
        ><ng-container *ngIf="account && account.subdomain == 'standard'">Rent Roll</ng-container></a
      >
      <ng-container *ngIf="account && account.subdomain == 'jacklingo'">
        <a [routerLink]="['./tenants']" [routerLinkActive]="['active']">Tenants</a>
      </ng-container>
    </ng-container>

    <!-- LOAN QUOTES TAB -->
    <a
      *ngIf="hasLoanQuotesEnabled$ | async"
      [routerLink]="[projectRoute + '/loans']"
      [routerLinkActive]="['active']"
      data-cy="project-loan-quotes-tab"
    >
      <ng-container *ngIf="account && account.subdomain == 'hearn'">LP Tracker</ng-container>
      <ng-container *ngIf="!account || account?.subdomain == 'demo'">Capital Markets</ng-container>
      <ng-container *ngIf="!account || account?.subdomain == 'subtext'">Equity Quotes</ng-container>
      <ng-container
        *ngIf="
          !account || (account?.subdomain != 'hearn' && account?.subdomain != 'demo' && account?.subdomain != 'subtext')
        "
        >Loan Quotes</ng-container
      >
      <span class="badge" *ngIf="project.num_loan_quotes && project.num_loan_quotes > 0">{{
        project.num_loan_quotes
      }}</span>
    </a>

    <ng-container *ngIf="account && account.subdomain == 'atindustrial'">
      <a [routerLink]="[projectRoute + '/sheets']" [routerLinkActive]="['active']"
        >Sheets
        <span class="badge" *ngIf="project.project_sheets && project.project_sheets?.length > 0">{{
          project.project_sheets?.length
        }}</span></a
      >
    </ng-container>

    <!-- DISPOSITIONS TAB -->
    <a
      *ngIf="canAccessDispositions$ | async"
      [routerLink]="[projectRoute + '/dispositions']"
      [routerLinkActive]="['active']"
    >
      Dispositions
    </a>

    <!-- CONTACTS TAB -->
    <a
      [appAuthorize]="hasPermission(Permission.CONTACTS_TAB)"
      [routerLink]="[projectRoute + '/contacts']"
      [routerLinkActive]="['active']"
      data-cy="project-contacts-tab"
    >
      Contacts
      <span class="badge" *ngIf="project.contact_associations && project.contact_associations.length > 0">
        {{ project.contact_associations.length }}
      </span>
    </a>

    <!-- VISIBLE CUSTOM OBJECTS TABS -->
    <ng-container *ngIf="hasCustomObjectPermission()">
      <ng-container *ngIf="hasCustomObjectsEnabled$ | async">
        <a
          *ngFor="let customObjectTab of visibleCustomObjectsTabs"
          [routerLink]="[projectRoute + '/custom_object', customObjectTab.id]"
          [queryParams]="{ related_to_type: relatedToTypeProject, related_to_id: project.id }"
          [routerLinkActive]="['active']"
        >
          {{ customObjectTab.label_plural || customObjectTab.label }}
        </a>

        <!-- HIDDEN CUSTOM OBJECTS TABS -->
        <ng-container *ngIf="hasDropDown">
          <a
            [routerLink]="[projectRoute + '/custom_object', selectedCustomObjectTab?.id]"
            [queryParams]="{ related_to_type: relatedToTypeProject, related_to_id: project.id }"
            [routerLinkActive]="['active']"
          >
            {{ selectedCustomObjectTab?.label_plural || selectedCustomObjectTab?.label }}
          </a>
          <button class="menuHiddenCO" mat-icon-button [matMenuTriggerFor]="menuHiddenCO">
            <mat-icon [svgIcon]="'expand_more'"></mat-icon>
          </button>
          <mat-menu #menuHiddenCO="matMenu">
            <button
              mat-menu-item
              *ngFor="let customObjectTab of hiddenCustomObjectsTabs"
              (click)="selectCustomObjectTab(customObjectTab, true)"
            >
              {{ customObjectTab.label_plural || customObjectTab.label }}
            </button>
          </mat-menu>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <div class="right" #rightContainer>
    <div class="flex items-center">
      <img
        src="{{ userAssociation.user.avatar_url }}"
        class="w-6 h-6 m-2px rounded-full text-card shadow-solid"
        *ngFor="let userAssociation of userAssociations; let i = index"
        [ngClass]="{ '-ml-3': i > 0 }"
        alt="{{ userAssociation.user.full_name }}"
      />
      <button
        mat-icon-button
        [matTooltip]="'Add User'"
        class=""
        [ngClass]="{ '-ml-1': userAssociations?.length > 0 }"
        (click)="openUserAssociationsPanel()"
        [appAuthorize]="Permission.PROJECT_ADD_USER"
        #userAssociationsPanelOrigin
      >
        <mat-icon [svgIcon]="'add_circle'"></mat-icon>
      </button>
    </div>
    <ng-template #userAssociationsPanel>
      <div class="contacts-details-tags-panel">
        <div class="tags-panel-header">
          <div class="new-tag">
            <mat-icon [svgIcon]="'search'"></mat-icon>
            <input
              type="text"
              placeholder="Find user"
              (input)="filterUserAssociations($event)"
              (keydown)="filterUserAssociationsInputKeyDown($event)"
              [maxLength]="50"
              #newTagInput
            />
          </div>
        </div>

        <div class="available-tags">
          <ng-container>
            <mat-checkbox
              *ngFor="let userAssociation of filteredUserAssociations; trackBy: trackByFn"
              [color]="'primary'"
              [checked]="projectUserIds.includes(userAssociation.user.id)"
              (change)="toggleUserAssociation(userAssociation, $event)"
              [disabled]="!userAssociation.user?.active"
            >
              {{ userAssociation.user.full_name }}
            </mat-checkbox>
          </ng-container>
        </div>
        <div class="create-tag" (click)="openInvitationModal()" matRipple>
          <mat-icon [svgIcon]="'add'"></mat-icon>
          <div>Invite Guest User</div>
        </div>
      </div>
    </ng-template>

    <button mat-icon-button (click)="fileInput.click()" class="ai-button" *ngIf="canAccessEthan">
      <img
        *ngIf="!ui.isAiLoading"
        src="assets/icons/ai-shine-stars-yellow.svg"
        class="ai-button-icon"
        alt="AI Ability"
      />
      <mat-spinner *ngIf="ui.isAiLoading" diameter="20" class="ai-button-spinner"></mat-spinner>
      <input
        data-cy="upload-photo-input"
        style="display: none"
        type="file"
        accept="image/jpeg, image/png, image/gif, application/pdf"
        (change)="onFileSelected($event)"
        multiple
        #fileInput
      />
    </button>

    <button
      class="previous-button w-7"
      (click)="goToPrevious()"
      mat-icon-button
      [matTooltip]="'Previous Deal'"
      [disabled]="!(currentProjectIndex > 0)"
    >
      <mat-icon [svgIcon]="'chevron_left'"></mat-icon>
    </button>
    <button
      class="next-button w-6"
      (click)="goToNext()"
      mat-icon-button
      [matTooltip]="'Next Deal'"
      [disabled]="!(projectList?.length > 0 && projectList?.length !== currentProjectIndex + 1)"
    >
      <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
    </button>
    <button
      [appAuthorize]="Permission.PROJECT_SHARE"
      class="previous-button"
      (click)="shareProject()"
      [matTooltip]="'Share Deal'"
      mat-icon-button
    >
      <mat-icon [svgIcon]="'share'" title="Share Deal"></mat-icon>
    </button>
    <button
      class="previous-button"
      (click)="toggleFavorite()"
      [matTooltip]="'Favorite/Unfavorite Deal'"
      mat-icon-button
    >
      <mat-icon
        [svgIcon]="'star'"
        title="Favorite/Unfavorite Deal"
        [ngClass]="isFavorited ? 'text-orange-500' : ''"
      ></mat-icon>
    </button>
    <button class="more-menu" mat-icon-button [matMenuTriggerFor]="moreMenu">
      <mat-icon [svgIcon]="'more_vert'"></mat-icon>
    </button>

    <mat-menu #moreMenu="matMenu">
      <button mat-menu-item (click)="exportProject('pdf')" [appAuthorize]="NewPermission.DEALS_SHARING_RECORDS">
        <mat-icon [svgIcon]="'picture_as_pdf'"></mat-icon>
        Export Deal Sheet PDF
      </button>
      <button mat-menu-item (click)="exportProject('csv')" [appAuthorize]="NewPermission.DEALS_SHARING_RECORDS">
        <mat-icon [svgIcon]="'file_copy'"></mat-icon>
        Export Deal Sheet CSV
      </button>
      <button mat-menu-item (click)="openGenerateModal()" [appAuthorize]="NewPermission.DEALS_SHARING_RECORDS">
        <mat-icon [svgIcon]="'description'"></mat-icon>
        Generate Merge Document
      </button>
      <button mat-menu-item (click)="openGenerateUnderwritingModal()">
        <mat-icon [svgIcon]="'functions'"></mat-icon>
        Generate Underwriting Model
      </button>
      <button mat-menu-item (click)="openGenerateUnderwritingModal(true)">
        <ts-icon icon="terminal"></ts-icon>
        Reforecast
      </button>
      <button mat-menu-item (click)="showSmartEmail()">
        <mat-icon [svgIcon]="'email'"></mat-icon>
        Smart Email
      </button>
      <button
        mat-menu-item
        (click)="changeProjectTemplate()"
        [appAuthorize]="Permission.PROJECT_DASHBOARD_EDIT_LAYOUT"
        denyAction="disable"
        [disabled]="isArchived"
      >
        <mat-icon [svgIcon]="'sync_alt'"></mat-icon>
        Change Layout
      </button>
      <button mat-menu-item (click)="changePipeline()" [disabled]="isArchived" [appAuthorize]="canEditDeal()">
        <mat-icon [svgIcon]="'list_alt'"></mat-icon>
        Move Views
      </button>
      <button
        mat-menu-item
        (click)="convertToPortfolio()"
        *ngIf="!isPortfolio && !hasParent()"
        [appAuthorize]="canEditDeal()"
      >
        <mat-icon [svgIcon]="'account_tree'"></mat-icon>
        Convert to Portfolio
      </button>
      <button mat-menu-item (click)="openCalculatorModal()">
        <mat-icon [svgIcon]="'functions'"></mat-icon>
        Calculator
      </button>
      <button mat-menu-item (click)="markAcquired()" *ngIf="!project.is_owner" [disabled]="isArchived">
        <mat-icon [svgIcon]="'done'"></mat-icon>
        Acquire/Pass
      </button>
      <button mat-menu-item *ngIf="project.is_owner">
        <mat-icon [svgIcon]="'done_all'"></mat-icon>
        Acquired
      </button>
      <button mat-menu-item (click)="syncToProcore()" *ngIf="procoreEnabled">
        <mat-icon [svgIcon]="'leak_add'"></mat-icon>
        Sync to Procore
      </button>
      <button
        mat-menu-item
        DebounceClick
        (debounceClick)="duplicateProject()"
        [disabled]="isArchived"
        [appAuthorize]="Permission.DEALS_ADD"
      >
        <mat-icon [svgIcon]="'difference'"></mat-icon>
        <span>Duplicate Deal</span>
      </button>

      <ng-container *ngIf="hasAccessArchiveProject$ | async">
        <ng-container *ngIf="!isArchived; then archiveButton; else unarchiveButton"></ng-container>
        <ng-template #archiveButton>
          <button mat-menu-item DebounceClick (debounceClick)="archiveProject()">
            <mat-icon [svgIcon]="'archive'"></mat-icon>
            <span>Archive Deal</span>
          </button>
        </ng-template>
        <ng-template #unarchiveButton>
          <button mat-menu-item DebounceClick (debounceClick)="unarchiveProject()">
            <mat-icon [svgIcon]="'unarchive'"></mat-icon>
            <span>Unarchive Deal</span>
          </button>
        </ng-template>
      </ng-container>

      <button [appAuthorize]="canDeleteDeal()" mat-menu-item (click)="deleteProject()" [disabled]="isArchived">
        <mat-icon [svgIcon]="'delete'"></mat-icon>
        <span>Delete Deal</span>
      </button>
    </mat-menu>
  </div>
</div>
